/**
 * Chinese Contact Translations
 * 联系页翻译模块 - 中文
 * 
 * 包含联系表单、联系信息、地图等翻译
 */

import type { ContactTranslations } from '../../types';

export const zhContact: ContactTranslations = {
  title: '联系我们',
  subtitle: '期待您的来信。',
  header: {
    title: '联系我们',
    subtitle: '期待您的来信。',
  },
  form: {
    firstName: '名',
    lastName: '姓',
    email: '电子邮箱',
    interested: '感兴趣的产品',
    selectProduct: '请选择',
    message: '留言内容',
    send: '发送留言',
    sending: '发送中...',
  },
  info: {
    headquarters: '总部',
    address: '福建省福州市马尾区亭江镇亭旺路26号万洋科技城B区B25座',
    phoneSupport: '电话支持',
    phone: '+86-15080458735',
    phoneHours: '周一至周五 9:00-18:00 (GMT+8)',
    emailUs: '给我们发邮件',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: '分销网络',
    distributorDesc: '我们正在寻找全球分销商。加入我们，将绿色取暖带到您的国家。',
  },
  success: {
    title: '留言已发送！',
    desc: '感谢您联系我们。我们的销售团队将在24小时内回复。',
    sendAnother: '再次发送留言',
  },
};
